import Enum from "@/util/enum";
import EnumValue from ".";

export default class Cmv extends Enum {
  static UNKNOWN: EnumValue = { name: "Unknown", code: 0 };
  static POSITIVE: EnumValue = { name: "Positive", code: 1 };
  static NEGATIVE: EnumValue = { name: "Negative", code: 2 };
}
